import { isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { vig_decode, vig_encode } from "../../../utils/VigenereCipher.js";

const USE_KEY = "FBFORGPREVENT";



type MODE_TYPE =  {
    popup: boolean,
    redirect: boolean
};

type MODE = keyof MODE_TYPE;

const MODE_CHECK: MODE_TYPE = {
    popup: true,
    redirect: true
};


export interface FBStateParam {

    u: string
    m: MODE

}


function isFBStateParam(obj: any): obj is FBStateParam {
    return isObject(obj) 
        && hasOwnProperty(obj, "u")
        && isString(obj["u"]) 
        && hasOwnProperty(obj, "m")
        && isString(obj["m"])
        && obj["m"] in MODE_CHECK;
}


export function encodeFBStateParam(state: FBStateParam): string {
    return vig_encode(JSON.stringify(state), USE_KEY);
}

export function decodeFBStateParam(str: string): FBStateParam|null {
    try {
        const obj = JSON.parse(vig_decode(str, USE_KEY));
        if(isFBStateParam(obj)) return obj;
        else return null;
    }
    catch(e) {
        return null;
    }
}